/**
 * formSelect
 * ------------------------------------------------------------------------------
 * This field changes state/prov based on country.
 * https://gist.github.com/montalvomiguelo/9cda21982732c4ebbce4804ff189e8be - shopify_common.js
 *
 * @namespace custom
 */
custom.formSelect = (() => {
  // ClassName Definition
  const selectClassName = 'js-custom-select';
  const initClassName = `${selectClassName}--initialized`;

  // Configuration
  const defaultPlaceholder = 'How did you hear about us?';

  function shopifyCountrySelectorInit(data = {}) {
    if (!Shopify) return;
    if ($(`.${data.className}`).hasClass(initClassName)) return;

    const formId = $(`.${data.className}`).data('form-id');
    const countrySelector = 'AddressCountry_' + formId;
    const provinceSelector = 'AddressProvince_' + formId;
    const containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });

    // NOTE: can't catch "change" event for Shopify CountryProvinceSelector,
    // So temporary leave as it is(not initialize with Select2)
    // init(data.className);
    window.pubsub.trigger('CountrySelectorValuePopulated');
  }

  function provinceValueSetter(data = {}) {
    window.pubsub.on('CountrySelectorValuePopulated', () => {
      $(`.${data.className}`).val(data.value).data('default', data);
      // init(data.className);
    });
  }

  function init(className = selectClassName) {
    $(`.${className}`).each((index, select) => {
      if ($(select).hasClass(initClassName)) return;
      const placeholder = $(select).data('placeholder') || defaultPlaceholder;
      $(select).select2({
        width: 'style',
        minimumResultsForSearch: Infinity,
        placeholder: placeholder,
      });
      $(select).addClass(initClassName);
    });
  }

  return {
    shopifyCountrySelectorInit,
    provinceValueSetter,
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/form-select.js